import { jwtDecode } from 'jwt-decode';
import { tokenStorage } from '../utils/encryptedCookie';

const useUsernameFromToken = () => {
  const getUsernameFromToken = () => {
    const token = tokenStorage.get();
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        return decodedToken.sub;
      } catch (error) {
        console.error('Erro ao decodificar o token:', error);
        return null;
      }
    }
    return null;
  };

  return {
    getUsernameFromToken,
  };
};

export default useUsernameFromToken;